import { jsx as t, jsxs as l } from "react/jsx-runtime";
import { FlexBox as s, Link as h, Typography as n } from "@vp/swan";
import a from "./help-center-articles-search29.js";
function d(r, e) {
  return `${r.landingUrl}${e}`;
}
const g = (r) => {
  const { searchItem: e, searchTerm: i } = r, o = `?swsquery=${encodeURIComponent(i)}&querycat=helpcenter_search_dropdown`;
  return /* @__PURE__ */ t(s, { style: { width: "100%" }, children: /* @__PURE__ */ l(
    h,
    {
      skin: "unstyled",
      style: { flexGrow: 1 },
      py: 4,
      px: 5,
      href: d(e, o),
      children: [
        /* @__PURE__ */ t(n, { visuallyHidden: !0, children: e.title }),
        /* @__PURE__ */ t(n, { "aria-hidden": "true", children: /* @__PURE__ */ t(
          a,
          {
            resultText: e?.highlightResult || e.title
          }
        ) })
      ]
    },
    `link_${e.objectID}`
  ) });
};
export {
  g as default
};
//# sourceMappingURL=help-center-articles-search23.js.map
